import { render, staticRenderFns } from "./SearchDept.vue?vue&type=template&id=2645159f&scoped=true&"
import script from "./SearchDept.vue?vue&type=script&lang=js&"
export * from "./SearchDept.vue?vue&type=script&lang=js&"
import style0 from "./SearchDept.vue?vue&type=style&index=0&id=2645159f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2645159f",
  null
  
)

export default component.exports